import { Divider, Modal, Paper, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import { TraineeChoiceDto } from "../../../../types/traineesTypes";

interface MotivationalTextsDialogProps {
  showMotivationalTexts: boolean;
  closeMotivationalTexts: () => void;
  openedTrainee: TraineeChoiceDto | null;
}

/**
 * Dialog which shows the motivational texts of a trainee for their internal project choices, opens when clicking on the "Motivationstexte anzeigen" button in the TraineePreferencesTable
 * @param showMotivationalTexts - A boolean indicating if the dialog should be shown
 * @param closeMotivationalTexts - A function to close the dialog
 * @param openedTrainee - The trainee whose motivational texts should be shown
 * @returns A Modal component showing the motivational texts of a trainee for their internal project choices
 */
const MotivationalTextsDialog = ({
  showMotivationalTexts,
  closeMotivationalTexts,
  openedTrainee,
}: MotivationalTextsDialogProps) => {
  const theme = useTheme();

  const styles = {
    motivationalTextPaper: {
      overflowY: "auto",
      position: "absolute",
      margin: "auto",
      top: "10%",
      left: "10%",
      right: "10%",
      bottom: "10%",
      width: "80%",
      display: "flex",
      justifyContent: "center",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    // Header text of a paper marking a section of a page
    paperHeaderText: {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    paperText: {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    // Header divider of a paper marking a section of a page
    paperHeaderDivider: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  };
  return (
    <Modal open={showMotivationalTexts} onClose={closeMotivationalTexts}>
      <Paper sx={styles.motivationalTextPaper}>
        <Grid container>
          <Grid xs={12}>
            <Typography variant="h5" sx={styles.paperHeaderText}>
              Motivation für{" "}
              {openedTrainee?.internalProjectChoice1ShortName === null
                ? "n/a"
                : openedTrainee?.internalProjectChoice1ShortName}
            </Typography>
            <Typography sx={styles.paperText}>{openedTrainee?.internalProjectChoice1Motivation}</Typography>
            <Divider sx={styles.paperHeaderDivider} />
            <Typography variant="h5" sx={styles.paperHeaderText}>
              Motivation für{" "}
              {openedTrainee?.internalProjectChoice2ShortName === null
                ? "n/a"
                : openedTrainee?.internalProjectChoice2ShortName}
            </Typography>
            <Typography sx={styles.paperText}>{openedTrainee?.internalProjectChoice2Motivation}</Typography>
            <Divider sx={styles.paperHeaderDivider} />
            <Typography variant="h5" sx={styles.paperHeaderText}>
              Motivation für{" "}
              {openedTrainee?.internalProjectChoice3ShortName === null
                ? "n/a"
                : openedTrainee?.internalProjectChoice3ShortName}
            </Typography>
            <Typography sx={styles.paperText}>{openedTrainee?.internalProjectChoice3Motivation}</Typography>
            <Divider sx={styles.paperHeaderDivider} />
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
};

export default MotivationalTextsDialog;
